/* HOST OF VINTAGE – motion.js
   Animationen ohne externe Bibliothek. Respektiert „Bewegung reduzieren“. */
(function () {
  'use strict';
  var root = document.documentElement;
  if (!window.HOV || !window.HOV.motion) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  root.classList.add('motion');

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var raf = window.requestAnimationFrame;

  /* ---------- 1. Überschriften Wort für Wort ---------- */
  function splitWords(el) {
    if (el.dataset.split) return;
    el.dataset.split = '1';
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var parts = n.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var m = document.createElement('span'); m.className = 'wm';
            var w = document.createElement('span'); w.className = 'wi'; w.textContent = p;
            w.style.setProperty('--wd', (i++ * 70) + 'ms');
            m.appendChild(w); frag.appendChild(m);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !n.matches('svg, .wm')) {
          walk(n);
        }
      });
    })(el);
  }
  $$('.section-head__title, .fh__title, .pdp__title, .final__title, .cart-empty__title').forEach(splitWords);

  /* ---------- 2. Sichtbarkeit (Reveal, Wörter, Zähler, Gruppen) ---------- */
  function countUp(el) {
    var raw = el.textContent;
    var m = raw.match(/[\d.,]+/);
    if (!m) return;
    var numStr = m[0];
    var hasComma = /,\d{1,2}$/.test(numStr);
    var target = parseFloat(numStr.replace(/\./g, '').replace(',', '.'));
    if (!isFinite(target) || target === 0) return;
    var dec = hasComma ? numStr.split(',')[1].length : 0;
    var start = performance.now(), dur = 1400 + Math.min(target, 400) * 2;
    function fmt(v) {
      var s = v.toFixed(dec).replace('.', ',');
      if (!hasComma && v >= 1000) s = Math.round(v).toLocaleString('de-DE');
      return raw.replace(numStr, s);
    }
    (function tick(now) {
      var p = Math.min(1, (now - start) / dur), e = 1 - Math.pow(1 - p, 4);
      el.textContent = fmt(target * e);
      if (p < 1) raf(tick); else el.textContent = raw;
    })(start);
  }

  var groups = '.grid, .bb__items, .wb__grid, .jr__track, .preview__points, .chips, .trust, .bumps, .fh__stats, .finder__opts, .ww__col ul, .calc__presets, .faqt__tabs';
  $$(groups).forEach(function (g) {
    Array.prototype.slice.call(g.children).forEach(function (c, i) {
      c.classList.add('stagger');
      c.style.setProperty('--sd', (i * 90) + 'ms');
    });
  });

  var watch = $$('.aa__stack, .reveal, .wm, .stagger, [data-count-up], .doc, .delivery, .mix, .jr__track, .pt__table');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var t = en.target;
        t.classList.add('in');
        if (t.matches('[data-count-up]')) countUp(t);
        io.unobserve(t);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.12 });
    watch.forEach(function (el) { io.observe(el); });
  } else {
    watch.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- 3. Hero-Auftritt ---------- */
  var hero = $('.fh');
  if (hero) raf(function () { raf(function () { hero.classList.add('hero--in'); }); });

  /* ---------- 4. Scroll: Fortschritt, Header, Parallax, Laufband-Tempo ---------- */
  var bar = document.createElement('div');
  bar.className = 'scroll-progress'; bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);
  var header = $('[data-header]');
  var parallax = $$('[data-parallax]');
  var tracks = $$('.marquee__track, .announce__track');
  var lastY = window.scrollY, lastT = performance.now(), ticking = false, boost = 1;

  function onScroll() {
    var y = window.scrollY;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    bar.style.transform = 'scaleX(' + (max > 0 ? y / max : 0) + ')';
    if (header) {
      header.classList.toggle('is-scrolled', y > 10);
      var drawerOpen = $('.drawer:not([hidden])');
      if (!drawerOpen) header.classList.toggle('is-hidden', y > lastY && y > 300);
    }
    parallax.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var sp = parseFloat(el.getAttribute('data-parallax')) || 0.15;
      var off = (r.top + r.height / 2 - window.innerHeight / 2) * sp;
      el.style.setProperty('--py', off.toFixed(1) + 'px');
    });
    var now = performance.now();
    var v = Math.abs(y - lastY) / Math.max(16, now - lastT);
    boost = Math.min(4, 1 + v * 1.6);
    lastY = y; lastT = now; ticking = false;
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; raf(onScroll); } }, { passive: true });
  onScroll();

  // Laufbänder beschleunigen beim Scrollen und bremsen weich ab
  (function speed() {
    boost += (1 - boost) * 0.05;
    tracks.forEach(function (t) {
      if (!t.getAnimations) return;
      t.getAnimations().forEach(function (a) { a.playbackRate = boost; });
    });
    raf(speed);
  })();

  /* ---------- 5. Hero: Cover folgen der Maus ---------- */
  if (fine && hero) {
    var stack = $('.finder', hero), ticket = null;
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      if (stack) stack.style.transform = 'perspective(1200px) rotateY(' + (x * 5) + 'deg) rotateX(' + (-y * 4) + 'deg)';
      if (ticket) ticket.style.translate = (x * -18) + 'px ' + (y * -14) + 'px';
    });
    hero.addEventListener('mouseleave', function () {
      if (stack) stack.style.transform = '';
      if (ticket) ticket.style.translate = '';
    });
  }

  /* ---------- 6. 3D-Kippen + Lichtreflex auf Karten ---------- */
  if (fine) {
    $$('.card, .upgrade, .aa__receipt, .bb__sum, .calc__card').forEach(function (c) {
      c.classList.add('tilt');
      var glare = document.createElement('span'); glare.className = 'glare'; glare.setAttribute('aria-hidden', 'true');
      c.appendChild(glare);
      c.addEventListener('mousemove', function (e) {
        var r = c.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        var k = c.classList.contains('tier') ? 5 : 7;
        c.style.setProperty('--rx', ((0.5 - py) * k).toFixed(2) + 'deg');
        c.style.setProperty('--ry', ((px - 0.5) * k).toFixed(2) + 'deg');
        c.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
        c.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
      });
      c.addEventListener('mouseleave', function () {
        c.style.setProperty('--rx', '0deg'); c.style.setProperty('--ry', '0deg');
      });
    });

    /* ---------- 7. Magnetische Buttons ---------- */
    $$('.btn--lg, .btn--xl, .header__cta, .xsell__add, .card__foot .btn').forEach(function (b) {
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.22, y = (e.clientY - r.top - r.height / 2) * 0.3;
        b.style.translate = x.toFixed(1) + 'px ' + y.toFixed(1) + 'px';
      });
      b.addEventListener('mouseleave', function () { b.style.translate = ''; });
    });
  }

  /* ---------- 8. Weiches Auf- und Zuklappen (FAQ) ---------- */
  $$('details.acc').forEach(function (d) {
    var sum = $('summary', d), body = $('.acc__body', d);
    if (!sum || !body) return;
    sum.addEventListener('click', function (e) {
      e.preventDefault();
      if (d.open) {
        var h = body.scrollHeight;
        body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 320, easing: 'cubic-bezier(.2,.7,.1,1)' })
          .onfinish = function () { d.open = false; };
      } else {
        d.open = true;
        var h2 = body.scrollHeight;
        body.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 420, easing: 'cubic-bezier(.2,.7,.1,1)' });
      }
    });
  });

  /* ---------- 9. Produkt fliegt in den Warenkorb ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add], [data-atc]');
    if (!btn) return;
    var src = btn.closest('.card, .gr, .finder__result, .pdp, .aa');
    var media = src && (src.querySelector('.card__media .cover, .gr__thumb .cover, .finder__cover .cover, .aa__receipt, .pdp__main-media .cover, .pdp__main-media img'));
    var target = $('.header__cart');
    if (!media || !target) return;
    var a = media.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!a.width || a.bottom < 0 || a.top > window.innerHeight) return;
    var clone = media.cloneNode(true);
    clone.className += ' fly';
    clone.style.cssText = 'position:fixed;left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px;margin:0;z-index:300;pointer-events:none;border-radius:18px;overflow:hidden;';
    document.body.appendChild(clone);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    clone.animate([
      { transform: 'translate(0,0) scale(1) rotate(0)', opacity: 1 },
      { transform: 'translate(' + dx * 0.45 + 'px,' + (dy * 0.45 - 140) + 'px) scale(.5) rotate(-8deg)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.05) rotate(12deg)', opacity: 0.3 }
    ], { duration: 900, easing: 'cubic-bezier(.65,0,.35,1)' }).onfinish = function () { clone.remove(); };
  }, true);

  /* ---------- 10. Konfetti, wenn der Mengenrabatt erreicht ist ---------- */
  var lastDone = !!$('.progress.is-done');
  function confetti(anchor) {
    var r = anchor.getBoundingClientRect();
    var colors = ['#B08D57', '#5B1B24', '#2F6B4F', '#EFE9DF', '#0D0D0E'];
    for (var i = 0; i < 36; i++) {
      var p = document.createElement('i');
      p.className = 'confetti';
      p.style.cssText = 'left:' + (r.left + r.width / 2) + 'px;top:' + (r.top + 20) + 'px;background:' + colors[i % colors.length] + ';';
      document.body.appendChild(p);
      var ang = Math.random() * Math.PI * 2, dist = 80 + Math.random() * 140;
      p.animate([
        { transform: 'translate(0,0) rotate(0)', opacity: 1 },
        { transform: 'translate(' + Math.cos(ang) * dist + 'px,' + (Math.sin(ang) * dist - 60) + 'px) rotate(' + (Math.random() * 720) + 'deg)', opacity: 1, offset: 0.6 },
        { transform: 'translate(' + Math.cos(ang) * dist * 1.2 + 'px,' + (Math.sin(ang) * dist + 120) + 'px) rotate(' + (Math.random() * 900) + 'deg)', opacity: 0 }
      ], { duration: 1300 + Math.random() * 500, easing: 'cubic-bezier(.2,.7,.3,1)' }).onfinish = (function (el) { return function () { el.remove(); }; })(p);
    }
  }
  var drawerBody = $('#CartDrawer [data-cart-body]');
  if (drawerBody && 'MutationObserver' in window) {
    new MutationObserver(function () {
      var done = $('.progress.is-done', drawerBody);
      if (done && !lastDone) setTimeout(function () { confetti(done); }, 450);
      lastDone = !!done;
    }).observe(drawerBody, { childList: true });
  }

  /* Theme-Editor: neu geladene Sektionen sofort sichtbar */
  document.addEventListener('shopify:section:load', function (e) {
    $$('.reveal, .wm, .stagger, .chain, .doc, .delivery, .mix', e.target).forEach(function (el) { el.classList.add('in'); });
  });
})();
